import { render, staticRenderFns } from "./FrontConfigAccesses.vue?vue&type=template&id=421ad9b2&scoped=true&"
import script from "./FrontConfigAccesses.vue?vue&type=script&lang=js&"
export * from "./FrontConfigAccesses.vue?vue&type=script&lang=js&"
import style0 from "./FrontConfigAccesses.vue?vue&type=style&index=0&id=421ad9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ad9b2",
  null
  
)

export default component.exports